import React, { ComponentProps } from 'react'
import { PortableText } from "@portabletext/react"
import YouTube from "react-youtube"
import getYouTubeId from 'get-youtube-id'

const serializers = {
	types: {
		youtube: ({ value }: { value: { url: string } }) => {
			const { url } = value
			const id = getYouTubeId(url) ?? undefined
			return <YouTube videoId={id} />
		}
	}
}

type BodyProps = {
	blocks: ComponentProps<typeof PortableText>["value"]
}

const ArticleBody: React.FC<BodyProps> = ({ blocks }) => {
	return <PortableText value={blocks} components={serializers} />
}

export default ArticleBody
